module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_6000.d7b74b5a.png";